import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import Box from '@mui/material/Box';

import { SidebarProvider } from '@src/context';
import { useSidebar } from '@src/context/hooks';
import { Sidebar } from '@src/layout';

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    const { auth } = context;
    try {
      await auth.verifyToken();
    }
    catch {
      try {
        await auth.refreshToken();
      }
      catch (e) {
        throw redirect({
          to: '/auth/login',
          search: {
            redirect: encodeURIComponent(location.href),
          },
        });
      }
    }
  },
  component: App,
});

const StyleSheet = {
  root: {
    display: 'flex',
    minHeight: '100vh',
  },
  main: ({ isCollapsed }) => ({
    flexGrow: 1,
    marginTop: (t) => `${t.layout.header.height}px`,
    height: (t) => `calc(100% - ${t.layout.header.height}px)`,
    width: (t) => `calc(100% - ${isCollapsed ? t.layout.sidebar.minWidth : t.layout.sidebar.maxWidth}px)`,
    backgroundColor: 'layout.main.light',
    overflow: 'auto',
    minHeight: '100vh',
    padding: '24px',
  }),
};

function Root(props) {
  return <Box {...props} sx={StyleSheet.root} />;
}

function Navigation() {
  return <Box component="nav"><Sidebar /></Box>;
}

function Main(props) {
  const { isCollapsed } = useSidebar();
  return <Box {...props} sx={StyleSheet.main({ isCollapsed })} component="main" />;
}

function App() {
  return (
    <SidebarProvider>
      <Root>
        <Navigation />

        <Main>
          <Outlet />
        </Main>
      </Root>
    </SidebarProvider>
  );
}
